// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("StoreItem", {
  id: __t.u64(),
  slug: __t.string(),
  category: __t.string(),
  name: __t.string(),
  description: __t.string(),
  priceCoins: __t.i64(),
  rarity: __t.string(),
  isAvailable: __t.bool(),
  isSeasonal: __t.bool(),
  previewAsset: __t.string(),
  createdAt: __t.u64(),
  availableFrom: __t.u64(),
  availableUntil: __t.u64(),
  assetData: __t.option(__t.string()),
});


